import React from 'react';
import { Card, Container, Row, Col, Alert } from 'react-bootstrap';

const TestPage: React.FC = () => {
  return (
    <Container className="mt-4">
      <Row>
        <Col>
          <Card className="shadow-sm">
            <Card.Header className="bg-primary text-white">
              <h3 className="mb-0">עמוד בדיקה</h3>
            </Card.Header>
            <Card.Body>
              <Alert variant="info" className="mb-4">
                <h4>ברוכים הבאים לעמוד הבדיקה!</h4>
                <p className="mb-0">
                  זהו עמוד בדיקה שנוצר כדי לבדוק את הפונקציונליות של המערכת.
                  כאן תוכלו לראות שהמערכת עובדת כמו שצריך.
                </p>
              </Alert>
              
              <Row>
                <Col md={6}>
                  <Card className="mb-3">
                    <Card.Header className="bg-success text-white">
                      סטטוס המערכת
                    </Card.Header>
                    <Card.Body>
                      <p><strong>✅ Frontend:</strong> פועל תקין</p>
                      <p><strong>✅ React:</strong> טעון בהצלחה</p>
                      <p><strong>✅ Bootstrap:</strong> עיצוב פעיל</p>
                      <p><strong>✅ Routing:</strong> ניווט עובד</p>
                    </Card.Body>
                  </Card>
                </Col>
                
                <Col md={6}>
                  <Card className="mb-3">
                    <Card.Header className="bg-warning text-dark">
                      מידע טכני
                    </Card.Header>
                    <Card.Body>
                      <p><strong>🌐 URL:</strong> {window.location.href}</p>
                      <p><strong>📅 תאריך:</strong> {new Date().toLocaleDateString('he-IL')}</p>
                      <p><strong>⏰ שעה:</strong> {new Date().toLocaleTimeString('he-IL')}</p>
                      <p><strong>🔧 סביבה:</strong> Development</p>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
              
              <Row>
                <Col>
                  <Card>
                    <Card.Header className="bg-info text-white">
                      הודעת בדיקה
                    </Card.Header>
                    <Card.Body>
                      <div className="text-center">
                        <h5 className="text-primary">🎉 המערכת פועלת בהצלחה!</h5>
                        <p className="lead">
                          כל הקומפוננטות נטענו כמו שצריך והניווט עובד תקין.
                        </p>
                        <p>
                          זהו טקסט בדיקה שנועד לוודא שהמערכת עובדת כמו שצריך.
                          אם אתם רואים את הטקסט הזה, זה אומר שהכל תקין!
                        </p>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default TestPage;
